import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';

import { PositionsActionsType } from 'common/src/modules/ui-components/table/custom-table.enums';
import { PositionGroupModel } from '../../models';

@Component({
  selector: 'rnpl-positions-group-context-menu',
  templateUrl: './positions-group-context-menu.component.html',
})
export class PositionsGroupContextMenuComponent {

  public _allGroups: PositionGroupModel[] = [];
  public positionsActionsType: typeof PositionsActionsType = PositionsActionsType;

  @Input() public group: PositionGroupModel;
  @Input() public set allGroups(allGroups: PositionGroupModel[]) {
    this._allGroups = [...(allGroups || [])]
      .filter(g => !g.system || g.isDefault);
      // .sort((a, b) => Number(a.isDefault) - Number(b.isDefault));
  }

  @Output() public positionsGroupAction: EventEmitter<{ actionType: PositionsActionsType, group: PositionGroupModel; orderNumber: number }> = new EventEmitter();

  @ViewChild('contextMenu', {static: false}) public contextMenu: ContextMenuComponent;

  constructor(
    private contextMenuService: ContextMenuService,
  ) {
  }

  public onContextMenu(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();


    this.contextMenuService.show.next({
      contextMenu: this.contextMenu,
      event: event,
      item: this.group,
    });
  }

  public contextMenuActionHandler(actionType, group, orderNumber?: number): void {
    this.positionsGroupAction.emit({
      actionType: actionType,
      group,
      orderNumber
    });
  }

}
